export class UpdatePlayerTokensRequest {
    static Message = 'UpdatePlayerTokensRequest';

    public playerId: string;
    public tokenDelta: number;

    constructor(playerId: string, tokenDelta: number) {
        this.playerId = playerId;
        this.tokenDelta = tokenDelta;
    }
}
